import { Grid, Typography } from "@mui/material";
import VideoPlayer from "features/video/VideoPlayer";
import VideoSwitcher from "features/video/VideoSwitcher";
import { ACTIVE_ABS, Video, Videos } from "features/video/videoVariants";
import React, { useEffect, useState } from "react";
import "./App.css";

function App() {
  const [currentVideo, setCurrentVideo] = useState<Video>(Videos[ACTIVE_ABS]);

  useEffect(() => {
    const initialVideo = localStorage.getItem("currentVideo");
    if (initialVideo) {
      const parsedVideo = JSON.parse(initialVideo);
      // Cater for selected video already existing in browser storage from previous demos
      if (!parsedVideo.data) {
        setCurrentVideo(Videos[ACTIVE_ABS]);
        return;
      }
      setCurrentVideo(parsedVideo);
    } else {
      setCurrentVideo(Videos[ACTIVE_ABS]);
    }
  }, []);

  const handleVideoChange = (selectedKey: string) => {
    const newVideo = JSON.stringify(Videos[selectedKey]);
    localStorage.setItem("currentVideo", newVideo);

    // Refresh the page so the video canvas fully reloads
    window.location.reload();
  };

  return (
    <div className="App">
      <div className="Container">
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <img src={"/heywood_logo.png"} alt={"Heywood Logo"} width={"50%"} />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant={"h1"}>Video ABS Demo</Typography>
            <Typography variant={"h2"}>{currentVideo.title}</Typography>
          </Grid>
        </Grid>
        <VideoPlayer
          id={currentVideo.id}
          content={currentVideo.data}
          variant={currentVideo.variant}
          playButtonColour={currentVideo.colour}
        />
        <VideoSwitcher
          currentVideoId={currentVideo.title}
          onChange={handleVideoChange}
        />
      </div>
    </div>
  );
}

export default App;
